import { c as _c } from "react/compiler-runtime";
import { useCompareContext } from '../../Context';
import { categoryLabelMapper } from '../../Context/utils';
import { useCreditCardCompareColumnContext } from '../ColumnContext';
import { useCreditCardCompareOfferContext } from '../OfferContext';
import { ContentText } from './components/ContentText';
import { GreatForContainer } from './GreatFor.container';
export function GreatFor() {
  const $ = _c(8);
  const {
    categoriesToShow
  } = useCompareContext();
  const {
    index
  } = useCreditCardCompareColumnContext();
  const {
    offer: t0
  } = useCreditCardCompareOfferContext();
  const {
    compareCategories
  } = t0;
  let T0;
  let t1;
  if ($[0] !== categoriesToShow || $[1] !== compareCategories || $[2] !== index) {
    const parsedCategories = compareCategories.map(_temp);
    T0 = GreatForContainer;
    t1 = categoriesToShow.map(category_0 => <ContentText key={`${category_0}-${index}`} color={parsedCategories.includes(category_0) ? "black" : "neutral.lighter"}>{category_0}</ContentText>);
    $[0] = categoriesToShow;
    $[1] = compareCategories;
    $[2] = index;
    $[3] = T0;
    $[4] = t1;
  } else {
    T0 = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[5] !== T0 || $[6] !== t1) {
    t2 = <T0>{t1}</T0>;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp(category) {
  return categoryLabelMapper[category];
}